import React, {Component} from "react";
import { connect } from 'react-redux';
import moment from 'moment';
// import MobileBackButton from "../../UI/Mobile/MobileBackButton/MobileBackButton";
import CommonCheckBox from "../../UI/CommonCheckBox/CommonCheckBox";

import SearchResultHeader from '../../UI/Headers/SearchResultHeader/SearchResultHeader';
import SearchResultHeaderCity from '../../UI/Headers/SearchResultHeader/SearchResultHeaderCity/SearchResultHeaderCity';
import SearchResultMobileHeading from '../../UI/Headers/SearchResultHeader/SearchResultMobileHeading/SearchResultMobileHeading';
import SearchResultHeaderBox from '../../UI/Headers/SearchResultHeader/SearchResultHeaderBox/SearchResultHeaderBox';

import { withRouter } from 'react-router-dom';

import * as uiActions from '../../../store/actions/index';
import * as flightActions from '../../../store/actions/index';
import * as sidebarActions from '../../../store/actions/index';
import { switchHeaderView } from '../../../store/actions/index';

import FlightHeaderQuickFilters from './FlightHeaderQuickFilters/FlightHeaderQuickFilters';

class FlightHeader extends Component {

  modifySearchDisplayHandler = () => {
    this.props.onToggleMobileBookingEngine();
    // if(window.innerWidth > 600 && window.innerWidth < 900) {
    //   this.props.onToggleTabletBookingEngine();
    // }
    this.props.onShowCloseMobileBookingEngineButton();
  }

  articleDisplayHandler = () => {
    this.props.onSetLoading();
    this.props.history.goBack();
    if(window.innerWidth < 600) {
    } else {
      this.props.onShowTabletBookingEngine();
    }
  }

  render() {
    window.onbeforeunload = this.articleDisplayHandler;
    const cityName = this.props.cityName;
    const origin = cityName[this.props.flightCode.substring(0, 3)];
    const destination = cityName[this.props.flightCode.substring(3, 6)];

    const dateOneWayDesktop = moment(this.props.date, 'DD-MM-YYYY').format('DD MMM, dddd');
    const dateOneWayPhone = moment(this.props.date, 'DD-MM-YYYY').format('DD MMM');
    const dateRoundTripDepart = moment(this.props.date, 'DD-MM-YYYY').format('DD MMM');
    const dateRoundTripArrival = moment(this.props.arrivalDate, 'DD-MM-YYYY').format('DD MMM');

    return (
      <SearchResultHeader>
            {/* <Media query="(max-width: 599px)">
              {matches =>
                matches ? <MobileBackButton onClick={this.articleDisplayHandler} style={{height: '3.4rem'}} /> : null}
            </Media>
            <Media query="(min-width: 599px) and (max-width: 900px)">
              {matches =>
                matches ? <MobileBackButton onClick={this.articleDisplayHandler} /> : null}
            </Media> */}
            <div className={`u-flex align-items-center justify-content-between u-width100Percent u-height100Percent`}>
              <h3 className={`u-phoneHide u-fontSize13 u-fontWeightRegular u-textColorDark`}>
                <span>
                  <SearchResultHeaderCity>{origin}</SearchResultHeaderCity>
                  <span className={`ml-1 mr-1`}>to</span>
                  <SearchResultHeaderCity>{destination}</SearchResultHeaderCity>
                </span>
                <span>
                  {
                    this.props.type === "O" ? 
                    <SearchResultHeaderBox type='1'><span>{dateOneWayDesktop}</span></SearchResultHeaderBox> : 
                    <SearchResultHeaderBox type='1'> {dateRoundTripDepart} to {dateRoundTripArrival}</SearchResultHeaderBox>
                  }
                  <SearchResultHeaderBox type='2'>{this.props.travellers} {this.props.travellers > 1 ? "Travellers" : "Traveller"}</SearchResultHeaderBox>
                  {
                    this.props.type === 'R' && this.props.isSidebarActive ? 
                    <SearchResultHeaderBox type='3' onClick={() => this.props.onCloseSidebar()}>Modify Search</SearchResultHeaderBox> : null
                  }
                </span>
              </h3>
              <div className={`u-flex f-row`}>
                  <CommonCheckBox checkboxtype='square' onChange={() => this.props.onToggleAgentProfit()} name='isAgentProfit' checked={this.props.showAgentProfit}></CommonCheckBox>
              </div>
              <SearchResultMobileHeading onClick={this.modifySearchDisplayHandler}>
                <span>
                  <SearchResultHeaderCity>{origin}</SearchResultHeaderCity>
                  <span className={`ml-1 mr-1`}>to</span>
                  <SearchResultHeaderCity>{destination}</SearchResultHeaderCity>
                </span>
                <span className={`pl-1 pr-1`}>|</span>
                <span className="u-noWrapWithEllipsis u-maxWidth140">
                  {this.props.type === "O" ? <span>{dateOneWayPhone},</span> : <span>{dateRoundTripDepart} to {dateRoundTripArrival},</span>}
                  <span className="ml-1">{this.props.travellers} {this.props.travellers > 1 ? "Travellers" : "Traveller"}</span>
                </span>
            </SearchResultMobileHeading>
          </div>
          { this.props.type === "R" ? <div className={`u-phoneShow u-borderTopNormal mt-3 mb-3`}></div> : null }
          { this.props.type === "R" ? <FlightHeaderQuickFilters/> : null }
      </SearchResultHeader>
    );
  }
};

const mapStateToProps = state => {
  return {
    date: state.flights.departDate,
    arrivalDate: state.flights.arrivalDate,
    travellers: state.flights.totalTravellers,
    cityName: state.flights.cityName,
    returnFlights: state.flights.returnFlights,
    headerView: state.ui.headerView,
    flightCode: state.flights.flightCode,
    isSidebarActive: state.roundTripSummary.sidebar,
    showAgentProfit: state.ui.showAgentProfit,
    refundableArray: state.flights.refundableArray,
    selectedStops: state.flights.selectedStops
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onShowTabletBookingEngine: () => dispatch(uiActions.showTabletBookingEngine()),
    onToggleMobileBookingEngine: () => dispatch(uiActions.toggleMobileBookingEngine()),
    onToggleTabletBookingEngine: () => dispatch(uiActions.toggleTabletBookingEngine()),
    onShowCloseMobileBookingEngineButton: () => dispatch(uiActions.showMobileCloseBookingEngineButton()),
    onSetLoading: () => dispatch(flightActions.setLoading()),
    onCloseSidebar: () => dispatch(sidebarActions.closeSidebar()),
    onToggleAgentProfit: () => dispatch(uiActions.toggleAgentProfit()),
    onSwitchHeaderView: (view) => dispatch(switchHeaderView(view)),
    onToggleRefundableFlights: () => dispatch(flightActions.toggleRefundableFlights()),
    onToggleNonStopFlights: () => dispatch(flightActions.toggleNonStopFlights())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FlightHeader));



// WEBPACK FOOTER //
// ./src/components/Flight/FlightHeader/FlightHeader.js